import * as yup from 'yup';

export const schema = yup.object({
  busca_produto: yup.object({
    label: yup.string().required(),
    value: yup.number().required(),
  }),
  cod_tipo_ajuste_origem: yup.object({
    label: yup.string().required(),
    value: yup.number().required(),
  }),
  qtd_ajuste: yup.string().required(),
  qtd_derivado: yup.string().required(),
  cod_produto_derivado: yup.object({
    label: yup.string().required(),
    value: yup.number().required(),
  }),
  cod_tipo_ajuste_derivado: yup.object({
    label: yup.string().required(),
    value: yup.number().required(),
  }),
});
